import { obfuscate } from './obfuscate'
import { Analytics } from '@codeleap/analytics'
import { QueryKeys } from '../api/session/queryKeys'

type AnalyticsEvents = {
  example: undefined
  test: {
    value: number
  }
}

export const analytics = new Analytics<AnalyticsEvents>({
  enabled: false,
  obfuscateKeys: obfuscate.keys,
  obfuscateValues: obfuscate.values,
  init() {
    // const analytics = fb.analytics()
    // analytics.setAnalyticsCollectionEnabled(true)
  },
  prepareData() {
    const extraData = {
      user: QueryKeys.me.getData(),
    }

    return extraData
  },
}, {
  onInteraction(obj) {
    // const analytics = fb.analytics()
    // analytics.logEvent('user_interaction', eventArgs)
  },
  onEvent(obj) {
    // const analytics = fb.analytics()
    // analytics.logEvent('app_action', eventArgs)
  },
  onError(err) {
    // logger.error('Analytics', err)
  },
})